import * as React from 'react'
import { Tab, Tabs } from 'components/ui'
import Heading from 'components/ui/heading'
import EditorBlockList from '../../editor-new-content/editor-block-list'
import { sectionBlocks } from '../../editor-new-content/helpers'
import GlobalSettingsTab from './global-settings-tab'

class ContentEditorSidebar extends React.Component<
  any,
  {
    tabIndex: number
  }
> {
  state: {
    tabIndex: number
  } = {
    tabIndex: 0,
  }
  _handleTabChange: (tabIndex: number) => void = (tabIndex: number) =>
    this.setState({
      tabIndex,
    })

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="content-editor__sidebar__header">
          <Heading size={500}>Edit & create</Heading>
        </div>
        <Tabs
          className="Tabs--green-back"
          index={this.state.tabIndex}
          onChange={this._handleTabChange}
        >
          <Tab label="Blocks">
            <EditorBlockList list={sectionBlocks} />
          </Tab>
          <Tab label="Settings">
            <GlobalSettingsTab />
          </Tab>
        </Tabs>
      </React.Fragment>
    )
  }
}

export default ContentEditorSidebar
